import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Clock = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 16 16" {...rest}>
      <circle
        cx="8"
        cy="8"
        r="6.0025"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3036 8.76761L8 7.99996V3.99829"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

Clock.propTypes = {
  color: PropTypes.string
};

Clock.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default Clock;
